/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-no-bind */
import React, { useCallback, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Grid } from '@material-ui/core';

import { TableFilterCardContainer } from 'app/WMS/styles/styles';

import PageMode from 'components/Tools/PageMode';
import DetailsItem from 'components/Tools/DetailsItem';

import InventoryDetailsTable from './InventoryDetailsTable';
import { IInventoryDetailsModalProps } from '../../types';

const InventoryDetailsModal: React.FC<IInventoryDetailsModalProps> = ({
  isOpen,
  closeModal,
  enableResevedButton,
  inventoryDetailData,
  handleOpenCollectModal,
}) => {
  const { t } = useTranslation();

  return (
    <PageMode
      isModal
      disableSubmit
      open={isOpen}
      closeWhenClickOutside
      handleClose={closeModal}
      title={String(t('screens.commom.detail'))}
    >
      <div className="wrapper">
        <div className="contentDetail">
          <TableFilterCardContainer withPadding>
            <div style={{ padding: '15px' }}>
              {inventoryDetailData[0]?.estoqueTotal !== undefined &&
                inventoryDetailData[0].estoqueTotal > 0 && (
                  <DetailsItem
                    card
                    title={`${t('screens.commom.total')} ${t(
                      'screens.commom.stock'
                    )}`}
                    value={inventoryDetailData[0].estoqueTotal.toString()}
                  />
                )}
              {inventoryDetailData[0]?.reservadoTotal !== undefined &&
                inventoryDetailData[0].reservadoTotal > 0 && (
                  <DetailsItem
                    card
                    title={`${t('screens.commom.total')} ${t(
                      'screens.reportsStock.reserved'
                    )}`}
                    value={inventoryDetailData[0].reservadoTotal.toString()}
                    id="divergent"
                  />
                )}
              {inventoryDetailData[0]?.disponivelTotal !== undefined &&
                inventoryDetailData[0]?.disponivelTotal > 0 && (
                  <DetailsItem
                    card
                    title={`${t('screens.commom.total')} ${t(
                      'screens.reportsStock.available'
                    )}`}
                    value={inventoryDetailData[0].disponivelTotal.toString()}
                    id="done"
                  />
                )}
            </div>
          </TableFilterCardContainer>
        </div>
      </div>
      <InventoryDetailsTable
        rows={inventoryDetailData}
        enableResevedButton={enableResevedButton}
        handleOpenCollectModal={handleOpenCollectModal}
      />
    </PageMode>
  );
};

export default InventoryDetailsModal;
